import { Paperclip } from 'lucide-react'
import { useRef } from 'react'

/** What the picker offers. Anything else can still be dropped, and is refused on its chip with a reason. */
export const ATTACH_ACCEPT = 'image/png,image/jpeg,image/webp,image/gif,application/pdf,.csv,.geojson,.json,.zip,.gpkg'

export interface AttachButtonProps {
  onFiles: (files: File[]) => void
  disabled?: boolean
}

/** The composer's paperclip: opens the file picker, several files at once. */
export function AttachButton({ onFiles, disabled = false }: AttachButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <>
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={disabled}
        aria-label="Attach files"
        title="Attach pictures, PDFs or data files"
        className="shrink-0 rounded-md border border-gray-300 px-[0.5em] py-[0.25em] text-gray-600 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
      >
        <Paperclip className="h-4 w-4" aria-hidden="true" />
      </button>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={ATTACH_ACCEPT}
        className="hidden"
        data-testid="assistant-attach-input"
        tabIndex={-1}
        aria-hidden="true"
        onChange={e => {
          const files = Array.from(e.target.files ?? [])
          // Emptied so picking the same file again is a new pick.
          e.target.value = ''
          if (files.length) onFiles(files)
        }}
      />
    </>
  )
}
